import React from 'react';
import {Platform, View} from 'react-native';
import {
  ActivityIndicator,
  IconButton,
  List,
  useTheme,
} from 'react-native-paper';
import BottomDrawer from 'react-native-animated-bottom-drawer';
import {useFileSelectOptions} from '../../../hooks/useFileSelectOptions';
import {useAppSelector} from '../../../store/hooks';

export function AttachmentDrawer({
  makePhoto,
  selectImage,
  selectFile,
  bottomDrawerRef,
}: ReturnType<typeof useFileSelectOptions>) {
  const theme = useTheme();
  const isProcessing = useAppSelector(
    state => state.upload.isUploadInProgress,
  );
  return (
    <BottomDrawer
      ref={bottomDrawerRef}
      initialHeight={200}
      customStyles={{
        container: {backgroundColor: theme.colors.background},
      }}>
      <List.Section>
        <List.Item
          title={
            isProcessing ? 'Import In Progress' : 'Import Attachment'
          }
          description={() => (
            <View style={{flexDirection: 'row'}}>
              {isProcessing ? (
                <ActivityIndicator size={36} />
              ) : (
                <>
                  {/* <IconButton
                icon="camera"
                onPress={makePhoto}
                style={{backgroundColor: theme.colors.secondary}}
                mode={'contained'}
                iconColor={theme.colors.onSecondary}
              /> */}
                  {Platform.OS !== 'web' && (
                    <IconButton
                      icon="image"
                      onPress={selectImage}
                      style={{
                        backgroundColor: theme.colors.secondary,
                      }}
                      mode={'contained'}
                      iconColor={theme.colors.onSecondary}
                    />
                  )}
                  <IconButton
                    icon="file"
                    onPress={selectFile}
                    style={{backgroundColor: theme.colors.secondary}}
                    mode={'contained'}
                    iconColor={theme.colors.onSecondary}
                  />
                </>
              )}
            </View>
          )}
        />
      </List.Section>
    </BottomDrawer>
  );
}
